(function () {
  'use strict';
  svgedit.history = svgedit.history || {};

  var processFunction = {
    '#href': function (attrValue) {
      svgedit.utilities.setHref(this.elem, attrValue);
    },
    '#fill': function (attrValue) {
      INKIVE.Helpers.setColor(this.elem, attrValue, 'fill');
    },
    '#stroke': function (attrValue) {
      INKIVE.Helpers.setColor(this.elem, attrValue, 'stroke');
    },
    '#set': function (attrValue, attrName) {
      INKIVE.Helpers.setColor(this.elem, attrValue, attrName.replace('#', ''));
    },
    '#layout-delete': function (attrValues) {
      _.each(['xlink:href', 'x', 'y', 'width', 'height'], function (attrName) {
        this.elem.setAttribute(attrName, attrValues[attrName]);
      }, this);

      var now = new Date();
      var unintendedChangeDelay = 4000;
      if ((now - this.storedTime) < unintendedChangeDelay) {
        this.svgCanvas && this.svgCanvas.call('advice.show', 'undo-unlocked-layout-image');
      }
    },
    '#bullets': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ bullets: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#text-anchor': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ text_anchor: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#text-decoration': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ text_decoration: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#font-weight': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ font_weight: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#font-style': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ font_style: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#font-family': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ font_family: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#font-size': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ font_size: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#word-spacing': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ word_spacing: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#paragraph-spacing': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ paragraph_spacing: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#first-line-margin': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ first_line_margin: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#right-margin': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ right_margin: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#letter-spacing': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ letter_spacing: attrValue });
      textarea.render(this.svgCanvas);
    },
    '#line-spacing': function (attrValue) {
      var textarea = new INKIVE.Text.Textarea().setDOM(this.elem);
      textarea.text.setValues({ line_spacing: attrValue });
      textarea.render(this.svgCanvas);
    },
    removeAttribute: function (attrName) {
      this.elem.setAttribute(attrName, '');
      this.elem.removeAttribute(attrName);
    },
    background: function () {
      var angle = svgedit.utilities.getRotationAngle(this.elem);

      if (angle) {
                // TODO: These instances of elem either need to be declared as global
                // (which would not be good for conflicts) or declare/use this.elem
        var bbox = this.elem.getBBox();
        var cx = bbox.x + bbox.width / 2,
          cy = bbox.y + bbox.height / 2;

        var rotate = ['rotate(', angle, ' ', cx, ',', cy, ')'].join('');
        if (rotate != this.elem.getAttribute('transform')) {
          this.elem.setAttribute('transform', rotate);
        }
      }
    },
    layoutClipper: function () {
      var clippathId = $(this.elem).closest('clippath').attr('id');
      var image = $('image[clip-path="url(#' + clippathId + ')"]')[0];

      image && $(document).trigger('editor.runExtensions', {
        name: 'setLayoutBoxCoord',
        data: {
          layoutBox: image,
          bbox: this.elem.getBBox()
        }
      });
    },
    default: function (attrName, attrValue1, attrValue2) {
      this.elem.setAttribute(attrName, attrValue1);
            // Update text element
      if (this.elem.parentElement && $(this.elem.parentElement).is('g.textarea')) {
        var textarea = new INKIVE.Text.Textarea().setDOM(this.elem.parentElement);
        textarea.render(this.svgCanvas);
      }
    }
  };

  function processChange (auxValues, attrValue, attrName) {
    if (attrValue) {
      if (processFunction[attrName]) processFunction[attrName].call(this, attrValue);
      else if (attrName.match(/^#set_/)) processFunction['#set'].call(this, attrValue, attrName);
      else processFunction['default'].call(this, attrName, attrValue, auxValues[attrName]);
    } else {
      switch (attrName) {
        case '#bullets': processFunction['#bullets'].call(this, attrValue); break;
        case '#text-anchor': processFunction['#text-anchor'].call(this, attrValue); break;
        case '#text-decoration':processFunction['#text-decoration'].call(this, attrValue); break;
        case '#font-weight': processFunction['#font-weight'].call(this, attrValue); break;
        case '#font-style': processFunction['#font-style'].call(this, attrValue); break;
        case '#word-spacing': processFunction['#word-spacing'].call(this, attrValue); break;
        case '#line-spacing': processFunction['#line-spacing'].call(this, attrValue); break;
        case '#letter-spacing': processFunction['#letter-spacing'].call(this, attrValue); break;
        case '#font-size': processFunction['#font-size'].call(this, attrValue); break;
        case '#font-family': processFunction['#font-family'].call(this, attrValue); break;
        case '#stroke': processFunction['#stroke'].call(this, attrValue); break;
        default: processFunction['removeAttribute'].call(this, attrName);
      }
    }
  }

  function abstractApply (aValues, bValues, handler) {
    document.body.contains(this.elem) || updateElement.call(this);

    _.each(aValues, _.bind(processChange, this, bValues));
    aValues['transform'] === '' && processFunction['background'].call(this);
    $(this.elem).is('rect.layoutClipper') && processFunction['layoutClipper'].call(this);

    svgedit.transformlist.removeElementFromListMap(this.elem);
    handler && handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.AFTER_APPLY, this);

    return true;
  }

  function updateElement () {
    var oldId = $(this.elem).data('old-id');
    var elem = _.find($('#svgcontent .element'), function (elem) {
      return elem.id === oldId;
    });
    this.elem = elem || this.elem;
  }

  svgedit.history.ChangeElementCommand = function (elem, attrs, text) {
    this.elem = elem;
    this.text = text ? ('Change ' + elem.tagName + ' ' + text) : ('Change ' + elem.tagName);
    this.newValues = {};
    this.oldValues = attrs;
    this.svgCanvas = INKIVE.Tool && INKIVE.Tool.getInstance().editor.canvas;
    var that = this;

    for (var attr in attrs) {
      if (attr == '#bullets') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.bullets;
      else if (attr == '#text-anchor') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.text_anchor;
      else if (attr == '#text-decoration') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.text_decoration;
      else if (attr == '#font-weight') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.font_weight;
      else if (attr == '#font-style') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.font_style;
      else if (attr == '#font-size') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.font_size;
      else if (attr == '#font-family') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.font_family;
      else if (attr == '#word-spacing') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.word_spacing;
      else if (attr == '#letter-spacing') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.letter_spacing;
      else if (attr == '#paragraph-spacing') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.paragraph_spacing;
      else if (attr == '#first-line-margin') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.first_line_margin;
      else if (attr == '#right-margin') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.right_margin;
      else if (attr == '#line-spacing') this.newValues[attr] = new INKIVE.Text.Textarea().setDOM(elem).text.line_spacing;
      else if (attr == '#href') this.newValues[attr] = svgedit.utilities.getHref(elem);
      else if (attr == '#fill') this.newValues[attr] = INKIVE.Helpers.getColor(elem, 'fill');
      else if (attr == '#stroke') this.newValues[attr] = INKIVE.Helpers.getColor(elem, 'stroke');
      else if (attr.match(/^#set_/)) this.newValues[attr] = INKIVE.Helpers.getColor(elem, attr.replace('#', ''));
      else if (attr == '#layout-delete') this.newValues[attr] = getLayoutValues();
      else this.newValues[attr] = elem.getAttribute(attr);
    }

    function getLayoutValues () {
      var values = {};
      _.each(['xlink:href', 'x', 'y', 'width', 'height'], function (attName) {
        values[attName] = elem.getAttribute(attName);
      });

      return values;
    }
  };

  svgedit.history.ChangeElementCommand.type = function () { return 'svgedit.history.ChangeElementCommand'; };
  svgedit.history.ChangeElementCommand.prototype.type = svgedit.history.ChangeElementCommand.type;

  svgedit.history.ChangeElementCommand.prototype.getText = function () {
    return this.text;
  };

  svgedit.history.ChangeElementCommand.prototype.apply = function (handler) {
    return abstractApply.call(this, this.newValues, this.oldValues, handler);
  };

  svgedit.history.ChangeElementCommand.prototype.unapply = function (handler) {
    return abstractApply.call(this, this.oldValues, this.newValues, handler);
  };

  svgedit.history.ChangeElementCommand.prototype.elements = function () {
    return [this.elem];
  };
})();
